// GENERATED by tools/levels (pnpm levels:build). Do not edit by hand.
import type { LogicPack } from "./schema.ts";

export const LOGIC_CONTENT_VERSION = "logic-1.0.0";

/** sha256 of each frozen chapter pack, checked by `pnpm levels:check`. */
export const LOGIC_PACK_SHA256: Readonly<Record<number, string>> = {
  1: "11e1bf45cb06b3e2c73aa611b087670ad62d25aa5ceaa5671fe2e08ac7c55eb0",
  2: "4a3832fe3b6718d3fb6f2a85e80fbeda2de9b9853ed0ac5d8b756fbf73f8cd54",
  3: "e235f426acac36a6979aa48a0efdb36529d0bb5bfee8fa85c8d39545456dc37e",
  4: "339b07d29837aeea224469ead7234158472dad45198552715f5ff7ced695cc3d",
  5: "f4395550178a4d5935fdd61d4fbc48e88b9cb31b1ee0682288f54bffac53f4e3",
  6: "03ad1508fc72d661ed30c061c566a74ef548e465b1b4272d008cc3c64e76d63d",
  7: "8a020d4e9bbb2fb9b8e37eff33a322a2d42863be0b723b10b1f61b37da8e8a03",
  8: "5b25b9059b3caa6df82950438b174807f30373166c7dc42f8fff4fe673da167f",
  9: "3867898fb6e7291043297cc7cffae42c2e60335a08137b1f962e25b4ece51a53",
  10: "167747691b55fde709c697ce3d976af0cf9ef841c138dd6f63c08ca34e5854c1",
};

/** Lazy loaders: the client only downloads the chapter being played. */
export const LOGIC_PACK_LOADERS: Readonly<Record<number, () => Promise<LogicPack>>> = {
  1: () => import("../../packs/logic/logic-1.0.0/chapter-01.json").then((m) => m.default as LogicPack),
  2: () => import("../../packs/logic/logic-1.0.0/chapter-02.json").then((m) => m.default as LogicPack),
  3: () => import("../../packs/logic/logic-1.0.0/chapter-03.json").then((m) => m.default as LogicPack),
  4: () => import("../../packs/logic/logic-1.0.0/chapter-04.json").then((m) => m.default as LogicPack),
  5: () => import("../../packs/logic/logic-1.0.0/chapter-05.json").then((m) => m.default as LogicPack),
  6: () => import("../../packs/logic/logic-1.0.0/chapter-06.json").then((m) => m.default as LogicPack),
  7: () => import("../../packs/logic/logic-1.0.0/chapter-07.json").then((m) => m.default as LogicPack),
  8: () => import("../../packs/logic/logic-1.0.0/chapter-08.json").then((m) => m.default as LogicPack),
  9: () => import("../../packs/logic/logic-1.0.0/chapter-09.json").then((m) => m.default as LogicPack),
  10: () => import("../../packs/logic/logic-1.0.0/chapter-10.json").then((m) => m.default as LogicPack),
};
